import styled, { keyframes } from "styled-components";
import { Colors } from "@blueprintjs/core";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const CountIconStyle = styled.span`
  color: ${props =>
    props.muted ? null : props.activeTextColor || Colors.GREEN3};
  margin-left: 0.5em;
  height: 1.5em;
  width: 2.5em;
  display: inline-flex;
  align-items: center;
  vertical-align: baseline;
  & .count-icon {
    color: ${props =>
      props.muted ? Colors.GRAY3 : props.activeIconColor || Colors.GREEN4};
  }
  & .count {
    display: inline-block;
    height: 1.1em;
    line-height: 1.1;
    margin: auto;
    height: 1em;
    ${props =>
      props.loading &&
      `
    animation: ${rotate360} 2s linear infinite;
    `};
  }
`;

export default CountIconStyle;



// WEBPACK FOOTER //
// ./src/app/CountIconStyle.js